import { useEffect } from 'react';
import useThemeStore from '../store';

const useThemeManager = () => {
    const { theme, setTheme } = useThemeStore();

    const applyTheme = (themeToApply, themeName = 'dark') => {
        const htmlElement = document.querySelector('html');
        htmlElement.classList.remove('light', 'dark');
        htmlElement.classList.add(themeToApply);
        setTheme(themeToApply);
        localStorage.setItem('theme', themeName);
    };

    const getSystemTheme = () => {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        }
        return 'light';
    }

    const handleSystemThemeChange = (e) => {
        const savedTheme = localStorage.getItem('theme');
        if (!savedTheme) {
            const newTheme = e.matches ? 'dark' : 'light';
            applyTheme(newTheme);
        }
    };

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        applyTheme(newTheme);
    };

    // Hook to manage the theme and make in first time default dark mode
    useEffect(() => {
        const hasForcedDark = localStorage.getItem('hasForcedDark');
        const htmlElement = document.querySelector('html');

        if (!hasForcedDark) {
            applyTheme('dark', 'dark');
            localStorage.setItem('hasForcedDark', 'true');
        }

        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        const handleChange = (e) => {
            const systemTheme = getSystemTheme();
            const savedTheme = localStorage.getItem('theme');

            if (savedTheme === 'system') {
                applyTheme(systemTheme, 'system');
            }
        };

        mediaQuery.addEventListener('change', handleChange);

        handleChange(mediaQuery);

        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);

    return {
        theme,
        setTheme,
        applyTheme,
        toggleTheme,
        getSystemTheme
    };
};

export default useThemeManager; 